import { t } from '@i18n';
import { Button, Group, Modal, Text } from '@mantine/core';
import { modals } from '@mantine/modals';

export default function NoAccount() {
  return (
    <>
      <Modal.Body>
        <Text>{t('login.noAccountText')}</Text>
      </Modal.Body>

      <Group justify="flex-end" mt="lg">
        <Button onClick={() => modals.closeAll()}>{t('common.ok')}</Button>
      </Group>
    </>
  );
}
